import { cx } from "@/utils";

import styles from "./Table.module.css";

export type TableProps = {
  className?: string;
  children?: React.ReactNode;
  tight?: boolean;
};

const Table: React.FunctionComponent<TableProps> = ({
  className,
  children,
  tight,
  ...rest
}) => {
  return (
    <table
      className={cx(styles.root, { [styles.tight]: tight }, className)}
      {...rest}
    >
      {children}
    </table>
  );
};

export default Table;
